import * as React from 'react';
function SvgError(props) {
    return (<svg width={30} height={30} {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#EB333F" cx={15} cy={15} r={15}/>
        <path d="M19.708 10.292a.999.999 0 00-1.413 0l-3.289 3.29-3.289-3.29a.999.999 0 00-1.412 1.413l3.289 3.289-3.29 3.289a.999.999 0 101.413 1.412l3.29-3.289 3.288 3.29a.999.999 0 001.413-1.413l-3.29-3.29 3.29-3.288a.999.999 0 000-1.413z" fill="#FFF" fillRule="nonzero"/>
      </g>
    </svg>);
}
export default SvgError;
